export function maskCpf(value) {
  const d = String(value || "").replace(/\D/g, "").slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9, 11)}`;
}

export function maskCnpj(value) {
  const d = String(value || "").replace(/\D/g, "").slice(0, 14);
  if (d.length <= 2) return d;
  if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`;
  if (d.length <= 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`;
  if (d.length <= 12) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12, 14)}`;
}

// CPF while typing (<=11 digits), switches to CNPJ mask beyond that
export function maskCpfCnpj(value) {
  const d = String(value || "").replace(/\D/g, "").slice(0, 14);
  return d.length > 11 ? maskCnpj(d) : maskCpf(d);
}

export function maskPhone(value) {
  const d = String(value || "").replace(/\D/g, "").slice(0, 11);
  if (d.length === 0) return "";
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7, 11)}`;
}

// Currency mask: "1234" → "12,34"  |  stores raw string like "12.34"
export function maskCurrency(value) {
  const d = String(value || "").replace(/\D/g, "").replace(/^0+/, "") || "0";
  const cents = d.padStart(3, "0");
  const intPart = cents.slice(0, -2).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${intPart},${cents.slice(-2)}`;
}

// Converts the masked display string back to a numeric string for the API ("12,34" → "12.34")
export function parseCurrency(masked) {
  const d = String(masked || "").replace(/\./g, "").replace(",", ".");
  return parseFloat(d) || 0;
}

export function validateCpf(cpf) {
  const d = String(cpf || "").replace(/\D/g, "");
  if (d.length !== 11) return false;
  if (/^(\d)\1+$/.test(d)) return false;
  let sum = 0;
  for (let i = 0; i < 9; i++) sum += +d[i] * (10 - i);
  let v1 = 11 - (sum % 11); if (v1 >= 10) v1 = 0;
  if (+d[9] !== v1) return false;
  sum = 0;
  for (let i = 0; i < 10; i++) sum += +d[i] * (11 - i);
  let v2 = 11 - (sum % 11); if (v2 >= 10) v2 = 0;
  return +d[10] === v2;
}

export function validateCnpj(cnpj) {
  const d = String(cnpj || "").replace(/\D/g, "");
  if (d.length !== 14) return false;
  if (/^(\d)\1+$/.test(d)) return false;

  const calcDigit = (base) => {
    let sum = 0;
    let pos = base.length - 7;
    for (let i = base.length; i >= 1; i--) {
      sum += base.charAt(base.length - i) * pos--;
      if (pos < 2) pos = 9;
    }
    const result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    return result;
  };

  const digits = d.substring(12);
  if (calcDigit(d.substring(0, 12)) !== +digits.charAt(0)) return false;
  return calcDigit(d.substring(0, 13)) === +digits.charAt(1);
}

export function validateCpfCnpj(value) {
  const digits = String(value || "").replace(/\D/g, "");
  if (digits.length === 11) return validateCpf(value);
  if (digits.length === 14) return validateCnpj(value);
  return false;
}
